import Vue from 'vue'

Vue.directive('context-menu', {
    bind: function (el, binding) {
        el.directiveEvent = function(ev) {
            el.$target = el.$target || $('#' + binding.value);
            el.$target.appendTo('body')
            el.$target.toggle();

            let docWidth = $(document).width(), docHeight = $(document).height(),
                elOffset = $(el).offset(),
                elWidth = $(el).outerWidth(), elHeight = $(el).outerHeight(),
                targetWidth = el.$target.outerWidth();

            el.$target.css({
                right: 'auto',
                bottom: 'auto',
                left: docWidth < elOffset.left + targetWidth ?
                    elOffset.left - (targetWidth - elWidth) :
                    elOffset.left + 'px',
                top: (elOffset.top + elHeight + 5) + 'px'
            })
        };
        el.hideEvent = function(ev){
            if(el.$target && el != ev.target){
                el.$target.hide();
            }
        }

        el.addEventListener('click', el.directiveEvent);
        document.body.addEventListener('click', el.hideEvent)
    },
    unbind: function(el, binding){
        el.removeEventListener('click', el.directiveEvent);
        document.body.removeEventListener('click', el.hideEvent);
        if(el.$target){
            el.$target.remove();
        }
    }
})


// WEBPACK FOOTER //
// ./Content/src/helpers/directives.js